const BASE_URL = '';

export const getToken = () => sessionStorage.getItem('token');

export const setToken = (token) => sessionStorage.setItem('token', token);

export const clearToken = () => sessionStorage.removeItem('token');

export const login = async (profile) => {
  const res = await fetch(`${BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profile)
  });
  return res.json();
};

export const validateRegistration = async (profile) => {
  const res = await fetch(`${BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...profile, validateOnly: true })
  });
  return res.json();
};

async function jsonOrThrow(res) {
  const data = await res.json();
  if (!res.ok) {
    const error = new Error(data.message || 'Request failed.');
    error.data = data;
    error.status = res.status;
    throw error;
  }
  return data;
}

export const fetchQuizStatus = async () => {
  const res = await fetch(`${BASE_URL}/api/quiz/status`, { cache: 'no-store' });
  return jsonOrThrow(res);
};

export const sessionLogin = async (teamNumber, phoneNumber, sessionType) => {
  const res = await fetch(`${BASE_URL}/api/auth/session-login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ teamNumber, phoneNumber, sessionType })
  });
  return jsonOrThrow(res);
};

export const fetchQuestions = async () => {
  const res = await fetch(`${BASE_URL}/api/quiz/questions`, {
    cache: 'no-store',
    headers: { Authorization: `Bearer ${getToken()}`, 'Cache-Control': 'no-cache' }
  });
  return jsonOrThrow(res);
};

export const saveQuizProgress = async (answers, currentQuestionIndex) => {
  const res = await fetch(`${BASE_URL}/api/quiz/progress`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    body: JSON.stringify({ answers, currentQuestionIndex })
  });
  return jsonOrThrow(res);
};

export const advanceQuiz = async (currentQuestionIndex) => {
  const res = await fetch(`${BASE_URL}/api/quiz/advance`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    body: JSON.stringify({ currentQuestionIndex })
  });
  return jsonOrThrow(res);
};

export const resumeQuizSession = async () => {
  const res = await fetch(`${BASE_URL}/api/quiz/resume`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  return jsonOrThrow(res);
};

export const pauseQuizSession = () => fetch(`${BASE_URL}/api/quiz/pause`, {
  method: 'POST',
  keepalive: true,
  headers: { Authorization: `Bearer ${getToken()}` }
});

export const submitAnswers = async () => {
  const res = await fetch(`${BASE_URL}/api/quiz/submit`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}` }
  });
  return jsonOrThrow(res);
};

export const checkStatus = async () => {
  const token = getToken();
  if (!token) return { valid: false };
  
  try {
    const res = await fetch(`${BASE_URL}/api/auth/status`, {
      headers: { Authorization: `Bearer ${token}` },
      cache: 'no-store'
    });
    return { ...(await res.json()), unavailable: !res.ok && res.status >= 500 };
  } catch (err) {
    return { valid: false, unavailable: true };
  }
};
